import classNames from "classnames";
import { useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Speaker } from "../../../../../../../../types/working-model";
import { tString } from "../../../../../../../../utils/translate-string";
import NavigationDropdown from "../../../../../../../general-ui/dropdown/navigation-dropdown";
import Icon, { COLORS, ICONS } from "../../../../../../../general-ui/icon";
import './speaker-card.scss';
import useInert from "@/hooks/use-inert";

type Props = {
	speaker: Speaker;
	selected?: boolean;
	handleSelectSpeaker?: (id: number, selected: boolean) => void;
	handleEdit?: (speaker: Speaker) => void;
	handleDelete?: (speaker: Speaker) => void;
	disabled?: boolean;
}

const SpeakerCard = ({
	speaker,
	selected,
	handleSelectSpeaker,
	handleDelete,
	handleEdit,
	disabled,
}: Props) => {
	const { speaker: id } = speaker;
	const { language } = useParams<{ language: string }>();
	const cardRef = useRef<HTMLDivElement>(null);

	// current version of react doesn't natively suppoert "inert"
	// and will strip it from the DOM, so using ref to set it
	useInert({ ref: cardRef, inert: !!disabled });

	return (
		<div
			ref={cardRef}
			className={classNames("panel-card speaker-card", { selected, 'speaker-card-disabled': disabled })}
			key={speaker.speaker}
			onClick={() => !disabled && handleSelectSpeaker?.(id as number, !selected)}
			aria-disabled={disabled}
		>
			<div
				className="speaker-image"
				style={{ backgroundImage: `url(${speaker.image})` }}
			/>
			<div className="speaker-data">
				<h5 className="speaker-name">{speaker.first_name} {speaker.last_name}</h5>
				<span className="speaker-job">{speaker.job_title ? tString(speaker.job_title, language) : ''}</span>
				<p className="speaker-description">{speaker.description ? tString(speaker.description, language) : ''}</p>
			</div>

			{!disabled && (handleEdit && handleDelete) && (
				<NavigationDropdown
					title={<Icon name={ICONS.THREE_DOTS_VERTICAL} size={20} color={COLORS.WHITE} />}
					className="added-card-dropdown"
					buttonClassName="question-card-options round no-style"
					edge="right"
					isArrow={false}
				>
					<>
						<button onClick={() => handleEdit(speaker)}>Edit</button>
						<button onClick={() => handleDelete(speaker)}>Delete</button>
					</>
				</NavigationDropdown>
			)}
		</div>
	);
};

export default SpeakerCard;